import React from 'react';
import LoaderImage from '../../../assets/images/progress.gif';

const Loader = ({visibility}) => {

  return (
    <div className={`loader-container ${visibility ? '' : 'hidden'}`}>
      <img src={LoaderImage} className="loader" />
    </div>
  )
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/commons/loader/loader.js